export default __webpack_public_path__ + "static/media/8f4a1705-214a-4dd0-80b8-72252c37e688.6e3568f6.ttf";